import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPerson = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9 9C9 7.34315 10.3431 6 12 6C13.6569 6 15 7.34315 15 9C15 10.6569 13.6569 12 12 12C10.3431 12 9 10.6569 9 9ZM12 4C9.23858 4 7 6.23858 7 9C7 10.5202 7.67847 11.882 8.74913 12.7991C6.52021 13.97 5 16.3075 5 19C5 19.5523 5.44772 20 6 20C6.55228 20 7 19.5523 7 19C7 16.2386 9.23858 14 12 14C14.7614 14 17 16.2386 17 19C17 19.5523 17.4477 20 18 20C18.5523 20 19 19.5523 19 19C19 16.3075 17.4798 13.97 15.2509 12.7991C16.3215 11.882 17 10.5202 17 9C17 6.23858 14.7614 4 12 4Z"
	})
});
export default SvgPerson;
